module.exports = __webpack_public_path__ + "static/media/desktop_windows.7c0dcc31.svg";